'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('InputListItem', function (theme) {
  return _defineProperty({
    root: {
      marginLeft: theme.typography.rhythmByUnit(6),
      marginRight: theme.typography.rhythmByUnit(4),
      marginTop: theme.typography.rhythmByUnit(4),
      backgroundColor: theme.palette.background.paper
    },
    form: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid ' + theme.palette.text.lightDivider,
      padding: theme.typography.rhythmByUnit(1)
    },
    input: {
      flexGrow: 1,
      marginLeft: theme.typography.rhythmByUnit(1),
      marginRight: theme.typography.rhythmByUnit(1)
    }
  }, theme.breakpoints.down('sm'), {
    button: {
      display: 'none'
    },
    root: {
      marginLeft: 0,
      marginRight: 0
    },
    form: {
      border: 'none',
      borderTop: '1px solid ' + theme.palette.text.lightDivider,
      borderRadius: 0,
      flex: 1
    }
  });
});

var InputListItem = (_temp = _class = function (_PureComponent) {
  _inherits(InputListItem, _PureComponent);

  function InputListItem() {
    _classCallCheck(this, InputListItem);

    return _possibleConstructorReturn(this, (InputListItem.__proto__ || Object.getPrototypeOf(InputListItem)).apply(this, arguments));
  }

  _createClass(InputListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            formClassNameProp = _props.formClassName,
            inputClassNameProp = _props.inputClassName,
            onSubmit = _props.onSubmit,
            icon = _props.icon,
            buttonProp = _props.button,
            other = _objectWithoutProperties(_props, ['className', 'formClassName', 'inputClassName', 'onSubmit', 'icon', 'button']);

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(classes.root, classNameProp);
        var formClassName = (0, _classnames2['default'])(classes.form, formClassNameProp);
        var inputClassName = (0, _classnames2['default'])(classes.input, inputClassNameProp);

        var button = (0, _react.isValidElement)(buttonProp) ? _react2['default'].cloneElement(buttonProp, {
          className: (0, _classnames2['default'])(classes.button, buttonProp.props.className)
        }) : buttonProp;

        return _react2['default'].createElement(
          'div',
          { className: rootClassName },
          _react2['default'].createElement(
            _Form2['default'],
            { className: formClassName, onSubmit: onSubmit },
            icon,
            _react2['default'].createElement(_Input2['default'], _extends({ className: inputClassName, underline: false }, other)),
            button
          )
        );
      }

      return render;
    }()
  }]);

  return InputListItem;
}(_react.PureComponent), _class.displayName = 'InputListItem', _class.propTypes = {
  /**
   * Classname applied to the root element
   */
  className: _PropTypes2['default'].string,
  /**
   * Classname applied to the form element
   */
  formClassName: _PropTypes2['default'].string,
  /**
   * Classname applied to the input element
   */
  inputClassName: _PropTypes2['default'].string,
  /**
   * Function called when form submission occurs
   */
  onSubmit: _PropTypes2['default'].func,
  /**
   * Optional icon to be displayed on the left side of the input
   */
  icon: _PropTypes2['default'].node,
  /**
   * Optional button to be displayed on the right side of the input
   */
  button: _PropTypes2['default'].node
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
}, _temp);
exports['default'] = InputListItem;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/InputListItem.js
// module id = 1823
// module chunks = 32